import { classNames } from '../../../../utils/style-class.utils';
export var tabInactive = function (isOnlyTab) {
    return "border-transparent hover:text-uiLight hover:border-uiLight whitespace-nowrap py-4 px-1 text-".concat(isOnlyTab ? 'start' : 'center', " border-b-4 items-").concat(isOnlyTab ? 'start' : 'center');
};
export var tabActive = function (isOnlyTab) {
    return "border-primary whitespace-nowrap py-4 px-1 border-b-4 items-".concat(isOnlyTab ? 'start' : 'center', " text-").concat(isOnlyTab ? 'start' : 'center');
};
export var getTabClass = function (activeTab, className, isOnlyTab) {
    if (isOnlyTab === void 0) { isOnlyTab = false; }
    var tabClassName = isOnlyTab ? 'pl-4 ' : ' ';
    tabClassName += activeTab ? tabActive(isOnlyTab) : tabInactive(isOnlyTab);
    if (className !== '') {
        tabClassName = classNames(tabClassName, className);
    }
    if (isOnlyTab) {
        tabClassName = tabClassName
            .replace('border-primary', '')
            .replace('border-b-4', '');
    }
    return tabClassName;
};
//# sourceMappingURL=tab.styles.js.map